import { Grid, FormControlLabel } from "@material-ui/core"
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { CheckboxSmall, FieldSetStyles } from "../../styles";

type SourceDateExtractionConfProps = {
    ignoreStaticDate: boolean,
    onIgnoreStaticDateChange: () => void,
    ignoreDynamicAnalyzeDate: boolean,
    onIgnoreDynamicAnalyzeDateChange: () => void,
    ignoreDiffbotDate: boolean,
    onIgnoreDiffbotDateChange: () => void,
    ignoreShivaDate: boolean,
    onIgnoreShivaDateChange: () => void,
    disabled?: boolean
}

export const SourceDateExtractionConf = ({
    ignoreStaticDate,
    onIgnoreStaticDateChange,
    ignoreDynamicAnalyzeDate,
    onIgnoreDynamicAnalyzeDateChange,
    ignoreDiffbotDate,
    onIgnoreDiffbotDateChange,
    ignoreShivaDate,
    onIgnoreShivaDateChange,
    disabled
}: SourceDateExtractionConfProps) => {

    const fieldSetStyles = FieldSetStyles();

    return <fieldset className={fieldSetStyles.container}>
        <legend>Date extraction settings:</legend>
        <Grid container>
            <Grid item xs={6}>
                <FormControlLabel
                    control={
                        <CheckboxSmall
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            name="ignoreStaticDate"
                            checked={ignoreStaticDate}
                            onChange={onIgnoreStaticDateChange}
                            size="small"
                            disabled={disabled}
                        />
                    }
                    label="Ignore Meta Date (Static)"
                />
            </Grid>
            <Grid item xs={6}>
                <FormControlLabel
                    control={
                        <CheckboxSmall
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            name="ignoreDynamicAnalyzeDate"
                            checked={ignoreDynamicAnalyzeDate}
                            onChange={onIgnoreDynamicAnalyzeDateChange}
                            size="small"
                            disabled={disabled}
                        />
                    }
                    label="Ignore Meta Date (Rendered)"
                />
            </Grid>
            <Grid item xs={6}>
                <FormControlLabel
                    control={
                        <CheckboxSmall
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            name="ignoreDiffbotDate"
                            checked={ignoreDiffbotDate}
                            onChange={onIgnoreDiffbotDateChange}
                            size="small"
                            disabled={disabled}
                        />
                    }
                    label="Ignore Diffbot date"
                />
            </Grid>
            <Grid item xs={6}>
                <FormControlLabel
                    control={
                        <CheckboxSmall
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            name="ignoreShivaDate"
                            checked={ignoreShivaDate}
                            onChange={onIgnoreShivaDateChange}
                            size="small"
                            disabled={disabled}
                        />
                    }
                    label="Ignore Custom Extraction date"
                />
            </Grid>
        </Grid>
    </fieldset>
}